import React from 'react'
import SignInHeader from '../../components/signIn/SignInHeader'
import SignUpTherapistForm from '../../components/SignUp/SignUpTherapistForm'
import TherapistSignUpFooter from '../../components/SigninTherapist/TherapistSignupFooter'
import SEO from '../../components/SEO/SEO'

function SignUpTherapist() {
    return (
        <>
        <SEO title="Therapist Registration" noIndex={true} />
        <div className="flex justify-center items-center min-h-screen">
            <div className="bg-tertiary rounded-[50px] mt-[76px] mb-32 p-6 sm:p-8 shadow-lg w-full max-w-[95%] md:max-w-[1039px] h-auto relative">
              <SignInHeader />
              <SignUpTherapistForm />
              <TherapistSignUpFooter />
            </div>
          </div>
        </>
      )
    }

export default SignUpTherapist